module.exports = __webpack_public_path__ + "img/logo_nb.e01d6df7.png";